import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {
  getEquipments(): DocumentNode {
    return gql`
      query getEquipments($where: EquipmentWhereInput, $orderBy: EquipmentOrderByInput, $limit: Int, $offset:Int) {
        equipments(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            number
            createdAt
            archived
            location {
              name
              address {
                formattedAddress
              }
            }
            type {
              name
            }
          }
        }
      }
    `;
  }

  getEquipment(): DocumentNode {
    return gql`
      query equipmentQuery($id: ID!) {
        equipment(id: $id) {
          id
          imageUrl
          name
          number
          qrCode
          createdAt
          notes
          archived
          location {
            id
            name
            address {
              formattedAddress
            }
          }
          type {
            id
            name
          }
          attachments {
            id
            path
            title
            createdAt
            archived
          }
          customFields {
            id
            name
            value
            position
            type
          }
          maintenances {
            id
            number
            location {
              name
            }
            segment {
              name
            }
            company {
              name
            }
            maintenanceType {
              name
            }
            status
            openedAt
          }
        }
      }
    `;
  }

  getFiltersData(): DocumentNode {
    return gql`
      query {
        locations: locationsNew(orderBy: { column: name, direction: asc }, limit: 100) {
          items {
            id
            name
          }
        }
        equipmentsTypes(orderBy: name_asc, limit: 100) {
          items{
            id
            name
          }
        }
        companies(orderBy: name_asc, limit: 100) {
          items {
            id
            name
          }
        }
      }
    `;
  }

  getEquipmentsTypes(): DocumentNode {
    return gql`
      query equipmentsTypes($where: EquipmentTypeWhereInput, $orderBy: EquipmentTypeOrderByInput) {
        equipmentsTypes(where: $where, orderBy: $orderBy) {
          items{
            id
            name
          }
        }
      }
    `;
  }

  getEquipmentType(): DocumentNode {
    return gql`
      query equipmentTypeQuery($id: ID!) {
        equipmentType(id: $id) {
          id
          name
        }
      }
    `;
  }
}
